import { lazy } from 'react'

export const FearVariant2 = lazy(() => import('./FearVariant2'))
